<div id="page-loader" *ngIf="isLoading" [class.is-fading]="isFading">
    <div class="loader-content">
        <img [src]="'cdn/ghrus-logo.webp' | cdnImage" alt="Logo"
            class="loader-logo img-fluid" width="200">
        <div class="loader-dots">
            <span></span><span></span><span></span>
        </div>
    </div>
</div>
